import {
    MetadataClassifierField,
    MetadataType,
} from "models/MetadataClassifierField";
import { AnswerPersistenceMode } from "models/AnswerPersistenceMode";
import { JsonPathFunction } from "models/JsonPathFunction";
import BaseService from "./BaseService";

export { AnswerPersistenceMode } from "models/AnswerPersistenceMode";

export interface QuestionMetadataRequest {
    OrganizationId: string;
    MetadataName: string;
    QuestionId: string;
    MetadataType: MetadataType;
    MetadataClassifierId?: string;
    metadataValueTagMap?: Record<string, string> | null;
    FieldPath?: string | null;
    AnswerPersistenceMode?: AnswerPersistenceMode;
}

export interface QuestionMetadataRecord {
    id: string;
    questionId: string;
    metadataName?: string;
    metadataType?: MetadataType;
    metadataClassifierId?: string;
    metadataValueTagMap?: Record<string, string> | null;
    fieldPath?: string | null;
    answerPersistenceMode?: AnswerPersistenceMode;
}

export default class QuestionMetadataService extends BaseService {
    protected urlBase: string = "api/QuestionMetadata";

    async getQuestionMetadata(orgId?: string): Promise<QuestionMetadataRecord[]> {
        const metadataFields = await this.get<QuestionMetadataRecord[]>(
            new URLSearchParams({ orgId: orgId ?? "" }),
            "",
        );

        return metadataFields;
    }

    async getAvailableMetadataClassifierFields(
        orgId: string,
    ): Promise<MetadataClassifierField[]> {
        return this.get<MetadataClassifierField[]>(
            new URLSearchParams({ orgId }),
            "GetAvailableMetadataClassifierFields",
        );
    }

    async getAvailableJsonPathFunctions(): Promise<JsonPathFunction[]> {
        return this.get<JsonPathFunction[]>(
            new URLSearchParams(),
            "GetAvailableJsonPathFunctions",
        );
    }
}
